const currentEnv = process.env.HOST_ENV;

const HS_URLS = {
    STAGING: "https://js.hs-scripts.com/20865732.js",
    PRODUCTION: "https://js-na1.hs-scripts.com/20450426.js"
};

export const HUBSPOT_ASSISTANCE_SCRIPT = HS_URLS[currentEnv];
